// @ts-nocheck
import { fetchPerformancesData, queryKey } from '~/queries'
import { addYears } from 'date-fns'


export function usePerformances(product) {
  const date = ref(null)
  const time = ref(null)
  const { data: performancesData, pending: performancesPending } = useAsyncData(
      queryKey('performances', product.data?.id),
      async () => {
        if (!product.hasPerformances) return

         return fetchPerformancesData({ productId: product?.id })
      },
      { server: false, lazy: true },
  );

  const performances = computed(() =>
    performancesData.value?.items.map((performance) => ({
      ...performance,
      date: performance.dateTime.split(' ')[0],
    })),
  )

  const availableDates = computed(() => {
    const dates = performances.value?.map((item) => item.date).sort()

    return [...new Set(dates)].map((date) => new Date(date))
  })

  const minDate = computed(() => {
    if (product.hasPerformances) {
      return availableDates.value[0] ?? new Date()
    }

    return new Date()
  })

  const maxDate = computed(() => {
    if (product.hasPerformances) {
      return availableDates.value[availableDates.value.length - 1] ?? new Date()
    }

    if (product.endDate) {
      return new Date(product.endDate)
    }

    return addYears(new Date(), 1)
  })

  const hasTickets = computed(() => {
    const now = new Date()

    return maxDate.value >= now
  })

  const disabledDates = computed(() => {
    if (!product.hasPerformances) return

    const startDate = minDate.value
    const endDate = maxDate.value
    const datesArray = []

    for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
      datesArray.push(new Date(d))
    }

    return datesArray.filter(
      (date) =>
        !availableDates.value.some(
          (availableDate) =>
            date.toISOString().split('T')[0] ===
            availableDate.toISOString().split('T')[0],
        ),
    )
  })

  const timeOptions = computed(
    () =>
      performances.value
        ?.filter((item) => item.date === date.value?.toISOString().split('T')[0])
        .map((item) => ({
          label: formatTime(item.dateTime),
          value: item.id,
          externalId: item.externalId,
        })) ?? [],
  )

  return {
    date,
    time,
    performances,
    availableDates,
    disabledDates,
    minDate,
    maxDate,
    hasTickets,
    timeOptions,
    performancesPending,
  }
}
